
import { supabase } from "@/integrations/supabase/client";
import { Category, Subcategory } from "@/types/category";

// This function extracts just the data fetching logic from useCategoriesQuery
export const fetchCategoriesData = async (): Promise<{
  categories: Category[];
  subcategories: Subcategory[];
}> => {
  console.log('Fetching categories data from centralized fetcher...');
  
  const [categoriesResult, subcategoriesResult] = await Promise.all([
    supabase
      .from('categories')
      .select('*')
      .order('order', { ascending: true }),
    supabase
      .from('subcategories')
      .select('*')
      .order('display_order', { ascending: true })
  ]);

  if (categoriesResult.error) {
    console.error('Error fetching categories:', categoriesResult.error);
    throw categoriesResult.error;
  }

  if (subcategoriesResult.error) {
    console.error('Error fetching subcategories:', subcategoriesResult.error);
    throw subcategoriesResult.error;
  }

  return {
    categories: categoriesResult.data as Category[],
    subcategories: subcategoriesResult.data as Subcategory[]
  };
};
